import React from "react";

const stripHtmlTags = (html) => {
  if (typeof html !== 'string') return '';
  try {
    if (typeof document === 'undefined') {
      return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    }
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  } catch (error) {
    return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
  }
};

const PrintPageFillInBlanks = ({options,question}) => {
  return (
    <>
      {options.map((option, optionIndex) => {
        const alphabetIndex = String.fromCharCode(65 + optionIndex);
        const words = question.highlightWords?.[optionIndex];
        const selectedAnswerData = question.answerSelected?.[optionIndex] || [];
        const selectedAnswers = selectedAnswerData?.map((data) => data?.text).filter(Boolean) || [];

        const cleanOption = stripHtmlTags(option || '');
        
        if (!words || words.length === 0) {
          return (
            <div key={optionIndex} style={{ marginBottom: "20px" }}>
              <div>
                <strong>{alphabetIndex}.</strong> {cleanOption}
              </div>
              {((question.type === "fillingImage" || question.fillingType === "Image") && question?.filling_image?.[optionIndex]?.url) ? (
                <img
                  src={question?.filling_image[optionIndex]?.url}
                  alt={`Match ${optionIndex}`}
                  draggable={false}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    marginTop: "5px",
                  }}
                />
              ) : null}
              {selectedAnswers.length > 0 && (
                <div style={{ marginTop: "10px" }}>
                  <span>Answers: </span>
                  <span>{selectedAnswers.join(", ")}</span>
                </div>
              )}
            </div>
          );
        }

        let currentIndex = 0;

        // Build the text with blanks
        const renderedOption = words?.map((word, wordIndex) => {
          const beforeText = cleanOption.slice(currentIndex, word.start);
          currentIndex = word.end;

          return (
            <span key={wordIndex}>
              {beforeText}
              <span
                style={{
                  display: "inline-block",
                  minWidth: "50px",
                  textAlign: "center",
                  borderBottom: "1px solid black",
                  margin: "0 4px",
                }}
              />
            </span>
          );
        });

        // Add the remaining text after the last blank
        const afterText = cleanOption.slice(currentIndex);

        return (
          <div key={optionIndex} style={{ marginBottom: "20px" }}>
            <div>
              <strong>{alphabetIndex}.</strong> {renderedOption}
              {afterText}
            </div>
            {question.type === "fillingImage" || (question.fillingType === "Image" && question?.filling_image?.[optionIndex]?.url) ? (
              <img
                src={question?.filling_image[optionIndex]?.url}
                alt={`Match ${optionIndex}`}
                draggable={false}
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  marginTop: "5px",
                }}
              />
            ) : null}
            <div style={{ marginTop: "10px" }}>
              <span>Answers: </span>
              <span>{selectedAnswers.join(", ")}</span>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default PrintPageFillInBlanks;
